export const SEARCH = {
  NO_RESULT: 'SEARCH_NO_RESULT',
  SEARCH_ALL: 'SEARCH_ALL',
  SEARCH_DO_FILTER: 'SEARCH_DO_FILTER',
  SEARCH_FINANCIAL_PUBLICATION_TYPE: 'SEARCH_FINANCIAL_PUBLICATION',
  SEARCH_INTERNATIONAL: 'SEARCH_INTERNATIONAL',
  SEARCH_MEDIA_TYPE: 'SEARCH_MEDIA',
  SEARCH_NATIONAL: 'SEARCH_NATIONAL',
  SEARCH_NEWS_TYPE: 'SEARCH_NEWS',
  SEARCH_OUR_MEDIA: 'SEARCH_OUR_MEDIA',
  SEARCH_OUR_NEWS: 'SEARCH_OUR_NEWS',
  SEARCH_OUR_SUGGESTIONS: 'SEARCH_OUR_SUGGESTIONS',
  SEARCH_PAGE_TYPE: 'SEARCH_PAGE',
  SEARCH_PLACEHOLDER: 'SEARCH_PLACEHOLDER',
  SEARCH_PUBLICATION_TYPE: 'SEARCH_PUBLICATION',
  SEARCH_REGION: 'SEARCH_REGION',
  SEARCH_RESET_REGION: 'SEARCH_RESET_REGION',
  SEARCH_RESET_THEMATICS: 'SEARCH_RESET_THEMATICS',
  SEARCH_SHOW_MORE_ALL: 'SEARCH_SHOW_MORE_ALL',
  SEARCH_SHOW_MORE_ALL_plural: 'SEARCH_SHOW_MORE_ALL',
  SEARCH_SHOW_MORE_MEDIA: 'SEARCH_SHOW_MORE_MEDIA',
  SEARCH_SHOW_MORE_MEDIA_plural: 'SEARCH_SHOW_MORE_MEDIAS',
  SEARCH_SHOW_MORE_NEWS: 'SEARCH_SHOW_MORE_NEWS',
  SEARCH_SHOW_MORE_NEWS_plural: 'SEARCH_SHOW_MORE_NEWS',
  SEARCH_SUBMIT: 'SEARCH_SUBMIT',
  SEARCH_TAB_LABEL_ALL: 'SEARCH_TAB_LABEL_ALL',
  SEARCH_TAB_LABEL_MEDIAS: 'SEARCH_TAB_LABEL_MEDIAS',
  SEARCH_TAB_LABEL_NEWS: 'SEARCH_TAB_LABEL_NEWS',
  SEARCH_THEMATICS: 'SEARCH_THEMATICS',
  SEARCH_TYPE_OF_CONTENT: 'SEARCH_TYPE_OF_CONTENT',
};
